import { ApiProvider } from "../utilities/core";

export const apiMiddleware = new ApiProvider({
  get: true,
  post: true,
});
